import React, { Fragment, useState } from 'react'
import { Col, Container, Form, FormGroup, Input, Label, Row } from 'reactstrap'
import { Btn, H4, P } from '../AbstractElements'
import { EmailAddress } from '../Constant'
import { Link } from 'react-router-dom'
import { forgotPass } from '../lib/auth'
import { ToastContainer, toast } from 'react-toastify'

const ForgotPassword = () => {
	const [email, setEmail] = useState('')
	const [submitting, setSubmitting] = useState(false)

	const handleSubmit = async (e) => {
		e.preventDefault()
		if (!email.trim()) {
			toast.error('Please enter your email address.')
			return
		}
		setSubmitting(true)
		const { error } = await forgotPass(email.trim())
		setSubmitting(false)
		if (error) {
			toast.error(error.message || 'Something went wrong. Please try again or contact support.')
			return
		}
		toast.success('If an account exists for this email, you will receive reset instructions shortly.')
	}

	return (
		<Fragment>
			<Container fluid={true} className="p-0 login-page">
				<Row>
					<Col xs="12">
						<div className="login-card">
							<div className="login-main login-tab">
								<Form className="theme-form" onSubmit={handleSubmit}>
									<div className="mb-3">
										<Link
											to={`${process.env.PUBLIC_URL}/login`}
											className="btn btn-outline-secondary d-inline-flex align-items-center gap-2"
										>
											<i className="fa fa-arrow-left" aria-hidden="true" />
											Back to sign in
										</Link>
									</div>
									<H4>Reset your password</H4>
									<P>Enter your email address and we will send you a link to choose a new password.</P>
									<FormGroup>
										<Label className="col-form-label">{EmailAddress}</Label>
										<Input
											className="form-control"
											type="email"
											autoComplete="email"
											placeholder="Enter your email address"
											value={email}
											onChange={(e) => setEmail(e.target.value)}
											disabled={submitting}
										/>
									</FormGroup>
									<div className="position-relative form-group mb-0">
										<Btn
											attrBtn={{
												color: 'primary',
												className: 'd-block w-100 mt-2',
												type: 'submit',
												disabled: submitting
											}}
										>
											{submitting ? 'Sending…' : 'Send reset link'}
										</Btn>
									</div>
								</Form>
							</div>
						</div>
					</Col>
				</Row>
			</Container>
			<ToastContainer />
		</Fragment>
	)
}

export default ForgotPassword
